import React, { useState, useEffect } from "react";
import {
  Table,
  Card,
  CardBody,
  CardTitle,
  Button,
  Collapse,
  Row,
  Spinner,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
//redux
import { connect } from "react-redux";
//paginação
import Pagination from "../../../components/Paginationv3";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// router
import { useLocation } from "react-router-dom";
//service e utils
import {
  getMatch,
  getStockRooms,
  delMatch,
  sendInviteConfirmation,
  getMatchNoRoom,
  deleteAllRooms,
} from "../../../utils/services/match";
import { getParticipants } from "../../../utils/services/participants";
import { useUserPermissions } from "../../../utils/hooks/useUserPermissions";
// componentes
import WaitExport from "../../../components/WaitExport";
import DeleteButton from "../../../components/Buttons/DeleteButton";
import useDebounce from "../../../utils/hooks/useDebounce";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import StockCard from "./StockCard";
import ModalEditStock from "./ModalEditStock";
import ModalLinksEmbeded from "./ModalLinksEmbeded";
import ModalConfig from "./ModalConfig";
import ModalExport from "./ModalExport";
import ModalExportByLine from "./ModalExportByLine";
import ModalExportNoRoom from "./ModalExportNoRoom";
import ModalPersonalizeMatch from "./ModalPersonalizeMatch";
import ModalCreateMatch from "./ModalCreateMatch";
import ModalImportRoom from "./ModalImportRoom";
import DashboardMatch from "./dashboard";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import IconButton from "../../../components/Buttons/IconButton";
import ModalConfirmDeleteAll from "../../../components/ModalConfirmDeleteAll";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";

const roomType = {
  4: "Quadruplo",
  3: "Triplo",
  2: "Duplo",
};

function Ranking(props) {
  const location = useLocation();
  const eventId = location.state.idEvent;
  const foundProducts = props.state.global_user_data.data.foundProducts;
  const { canCreate } = useUserPermissions();

  //state do modal
  const [modal, setModal] = useState(false);
  const [modalLinksEmbeded, setModalLinksEmbded] = useState(false);
  const [extractPointsModal, setExtractPointsModal] = useState(false);
  const [modalConfig, setModalConfig] = useState(false);
  const [modalExport, setModalExport] = useState(false);
  const [modalExportByLine, setModalExportByLine] = useState(false);
  const [modalExportNoRoom, setModalExportNoRoom] = useState(false);
  const [modalCreateMatch, setModalCreateMatch] = useState(false);
  const [modalImportRoom, setModalImportRoom] = useState(false);
  const [modalDashboard, setModalDashboard] = useState(false);
  const [modalDeleteAll, setModalDeleteAll] = useState(false);

  const [randomMatchUsers, setRandomMatchUsers] = useState(false);
  //state de pesquisa
  const [search, setSearch] = useState("");
  //paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  const [countData, setCountData] = useState(1);
  const [data, setData] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const debouncedSearch = useDebounce(search, 300);
  //ranking export
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [alertDeleted, setAlertDeleted] = useState(false);
  // state player points
  const [selectedMatch, setSelectedMath] = useState("");
  //count
  const [count, setCount] = useState(0);
  // collapse
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenReport, setIsOpenReport] = useState(false);
  const [isOpenMatch, setIsOpenMatch] = useState(false);
  //modais
  const [modalEditStock, setModalEditStock] = useState(false);
  //
  const [stockRooms, setStockRooms] = useState([]);
  //dropdown
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownRoom, setDropdownRoom] = useState(false);
  //
  const [confirmPending, setConfirmPending] = useState(false);
  //wait
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);
  const [position, setPosition] = useState("0%");
  const [pendingUsers, setPendingUsers] = useState(0);
  const [amountNoRoom, setAmountNoRoom] = useState(0);
  const [roomAmount, setRoomAmount] = useState(0);
  // confirmar quarto
  const [confirmRoomAlert, setConfirmRoomAlert] = useState(false);
  const [confirmedRoomAlert, setConfirmedRoomAlert] = useState(false);
  const [confirmRoomData, setConfirmRoomData] = useState(null);
  // deletar todos
  const [alertDeleteAll, setAlertDeleteAll] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  // participantes no evento
  const [haveParticipants, setHaveParticipants] = useState(false);
  // exibir botão deletar todos
  const [showDeleteAll, setShowDeleteAll] = useState(false);

  const [isActiveRoom, setIsActiveRoom] = useState(true);
  const [transition, setTransition] = useState(false);

  const [loading, setLoading] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  function toggleModal() {
    setModal(!modal);
  }

  function toggleModalCreateMatch() {
    setModalCreateMatch(!modalCreateMatch);
  }
  function toggleEditStock() {
    setModalEditStock(!modalEditStock);
    getStock();
  }

  function toggleLinksEmbeded() {
    setModalLinksEmbded(!modalLinksEmbeded);
  }

  function toggleExtractPointsModal() {
    setExtractPointsModal(!extractPointsModal);
  }
  async function deleteMatch(id) {
    await delMatch({
      id: id,
      jwt: props.state.global_user_data.data.token,
    })
      .then((response) => {
        setConfirmDelete(false);
        setAlertDeleted(true);
        getAllMatchFunc();
        getStock();
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  async function getStock() {
    await getStockRooms({
      eventId: eventId,
      jwt: props.state.global_user_data.data.token,
    })
      .then((response) => {
        setRoomAmount(response.filter((e) => e.disponivel > 0).length);
        setStockRooms(response);
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  async function setAllUsersCompleted() {
    setExportInProgress(true);
    await getMatch({
      eventId: eventId,
      jwt: props.state.global_user_data.data.token,
      offset: 1,
      limit: 9999999,
      search: "",
    })
      .then(async (response) => {
        const resultados = response.data.reduce((acc, e) => {
          const ids = [];

          for (let i = 1; i <= 4; i++) {
            const statusKey = `login_status_${i}`;
            const idKey = `login_id_${i}`;

            if (e[statusKey] === "pending_accept" && e[idKey] !== null) {
              ids.push(e[idKey]);
            }
          }

          if (ids.length > 0) {
            acc.push(ids);
          }

          return acc;
        }, []);

        for (let r = 0; r < resultados.length; r++) {
          for (let s = 0; s < resultados[r].length; s++) {
            await confirmInvit(resultados[r][s]);
          }
        }
      })
      .catch((error) => {
        // console.log("erro", error);
      });
    setFinishExport(true);
    setPosition(`${100}%`);
  }

  async function confirmRoom() {
    if (!confirmRoomAlert) {
      setConfirmRoomAlert(true);
      return;
    }

    try {
      const ids = [];

      for (let i = 1; i <= 4; i++) {
        const statusKey = `login_status_${i}`;
        const idKey = `login_id_${i}`;

        if (
          confirmRoomData[statusKey] === "pending_accept" &&
          confirmRoomData[idKey] !== null
        ) {
          ids.push(confirmRoomData[idKey]);
        }
      }

      ids.forEach(async (id) => {
        await confirmInvit(id);
      });

      setConfirmRoomAlert(false);
      setConfirmedRoomAlert(true);
    } catch (error) {
      // console.log("erro individual", error);
    }
  }

  async function confirmInvit(id) {
    await sendInviteConfirmation({
      eventId: eventId,
      roommateId: id,
      type: "completed",
      idiom: "ptBr",
      sendEmail: false,
      jwt: props.state.global_user_data.data.token,
    });
    // .then((res) => console.log("ok", res))
    // .catch((error) => console.log("erro", error));
  }

  async function getAllMatchFunc() {
    await getMatchNoRoom({
      eventId: eventId,
      limit: 100000000,
      offset: 1,
      jwt: props.state.global_user_data.data.token,
    }).then(async (res) => {
      const { count, data } = res;
      setAmountNoRoom(count);
    });
    setLoading(true);
    await getMatch({
      eventId: eventId,
      jwt: props.state.global_user_data.data.token,
      offset: currentIndex > 0 ? currentIndex : 1,
      limit: itemsPerPage,
      search: debouncedSearch,
      active: isActiveRoom,
    })
      .then((response) => {
        setData(response.data);
        setCountData(response?.data?.length);
        setCount(response.count);
        setLoading(false);
        setTransition(false);
      })
      .catch((error) => {
        // console.log(error);
        setLoading(false);
      });
  }

  async function verifyUsersPending() {
    await getMatch({
      eventId: eventId,
      jwt: props.state.global_user_data.data.token,
      offset: 1,
      limit: 10000,
      search: debouncedSearch,
      active: isActiveRoom,
    }).then((res) => {
      const resultados = res.data.reduce((acc, e) => {
        const ids = [];

        for (let i = 1; i <= 4; i++) {
          const statusKey = `login_status_${i}`;
          const idKey = `login_id_${i}`;

          if (e[statusKey] === "pending_accept" && e[idKey] !== null) {
            ids.push(e[idKey]);
          }
        }

        if (ids.length > 0) {
          acc.push(ids);
        }

        return acc;
      }, []);
      setPendingUsers(resultados.length);
    });
    // .catch((error) => console.log("match erro", error));
  }

  function getCardStock() {
    return stockRooms.map((e) => (
      <StockCard
        type={e.descricao}
        stock={e.disponivel}
        used={e.preenchido}
        total={e.total}
      />
    ));
  }

  async function deleteAllRoomsFunc() {
    setLoadingDelete(true);

    await deleteAllRooms(eventId)
      .then((res) => {
        setAlertDeleteAll(true);
        setLoadingDelete(false);
        getAllMatchFunc();
        getStock();
      })
      .catch((error) => {
        // console.log("erro", error);
        setLoadingDelete(false);
      });
  }

  useEffect(() => {
    verifyUsersPending();

    try {
      getParticipants({
        idEvent: eventId,
        offset: 1,
        limit: 10,
        search: "",
        columnSearch: "login",
        status: "ATIVO",
      }).then((res) => {
        if (res.message === "users" && res.data.count > 0) {
          setHaveParticipants(true);
        }
      });
      // .catch((error) => console.log("parts err", error));
    } catch (error) {
      // console.log("erro func", error);
    }
  }, []);

  useEffect(() => {
    getAllMatchFunc();
    getStock();
  }, [currentIndex, itemsPerPage, debouncedSearch, isActiveRoom]);

  return (
    <div>
      {modalDeleteAll && (
        <ModalConfirmDeleteAll
          isOpen={modalDeleteAll}
          toggle={() => setModalDeleteAll(false)}
          title="Deletar Quartos"
          onConfirm={deleteAllRoomsFunc}
        />
      )}

      <WaitExport
        customFinishTitle={"Preenchimento concluído."}
        customHeaderText={"Preenchendo Quartos"}
        customBodyText={`Em breve o preenchimento dos quartos será concluído, aguarde alguns instantes.`}
        isOpen={exportInProgress}
        name="Participantes sem Quarto"
        preposicao="dos"
        finishExport={finishExport}
        setFinishExport={() => {
          getAllMatchFunc();
        }}
        setExportInProgress={setExportInProgress}
        position={position}
      />
      {modalCreateMatch && (
        <ModalCreateMatch
          isOpen={modalCreateMatch}
          toggle={toggleModalCreateMatch}
          data={stockRooms}
          eventId={eventId}
          updateTables={() => {
            getAllMatchFunc();
            getStock();
          }}
        />
      )}
      {modalEditStock && (
        <ModalEditStock
          isOpen={modalEditStock}
          toggle={toggleEditStock}
          data={stockRooms}
          eventId={eventId}
        />
      )}

      {modalLinksEmbeded && (
        <ModalLinksEmbeded
          isOpen={modalLinksEmbeded}
          toggle={toggleLinksEmbeded}
          eventId={eventId}
        />
      )}

      {modalConfig && (
        <ModalConfig
          isOpen={modalConfig}
          toggle={() => setModalConfig(!modalConfig)}
          eventId={eventId}
          jwt={props.state.global_user_data.data.token}
          products={foundProducts}
        />
      )}

      {modalExport && (
        <ModalExport
          isOpen={modalExport}
          toggle={() => setModalExport(!modalExport)}
          jwt={props.state.global_user_data.data.token}
          eventId={eventId}
          count={count}
        />
      )}

      {modalExportByLine && (
        <ModalExportByLine
          isOpen={modalExportByLine}
          toggle={() => setModalExportByLine(false)}
          eventId={eventId}
          count={count}
        />
      )}

      {modalExportNoRoom && (
        <ModalExportNoRoom
          isOpen={modalExportNoRoom}
          toggle={() => setModalExportNoRoom(!modalExportNoRoom)}
          jwt={props.state.global_user_data.data.token}
          eventId={eventId}
        />
      )}

      {modalImportRoom && (
        <ModalImportRoom
          isOpen={modalImportRoom}
          toggle={() => setModalImportRoom(!modalImportRoom)}
          jwt={props.state.global_user_data.data.token}
          eventId={eventId}
          stockRooms={stockRooms}
          updateTables={() => {
            getAllMatchFunc();
            getStock();
          }}
        />
      )}

      {randomMatchUsers && (
        <ModalPersonalizeMatch
          roomAmount={roomAmount}
          isOpen={randomMatchUsers}
          toggle={() => setRandomMatchUsers(!randomMatchUsers)}
          jwt={props.state.global_user_data.data.token}
          eventId={eventId}
          updateTables={() => {
            getAllMatchFunc();
            getStock();
          }}
        />
      )}

      {modalDashboard && (
        <DashboardMatch
          isOpen={modalDashboard}
          toggle={() => setModalDashboard(false)}
          eventId={eventId}
        />
      )}

      {confirmDelete ? (
        <SweetAlert
          title={`Deseja deletar o registro?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            deleteMatch(selectedMatch.id);
          }}
          onCancel={() => setConfirmDelete(false)}
        >
          Você não poderá reverter essa ação.
        </SweetAlert>
      ) : null}

      {alertDeleted ? (
        <SweetAlert
          success
          title={"Sucesso"}
          onConfirm={() => {
            setAlertDeleted(false);
          }}
        >
          Quarto deletado com sucesso
        </SweetAlert>
      ) : null}

      {confirmPending ? (
        <SweetAlert
          title={`Deseja confirmar todos os participantes pendentes?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            setAllUsersCompleted();
            setConfirmPending(false);
          }}
          onCancel={() => setConfirmPending(false)}
        >
          Você não poderá reverter essa ação.
        </SweetAlert>
      ) : null}

      {confirmRoomAlert ? (
        <SweetAlert
          title={`Deseja confirmar todos os participantes desse quarto?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            confirmRoom();
          }}
          onCancel={() => setConfirmRoomAlert(false)}
        >
          <a>Você não poderá reverter essa ação.</a>
        </SweetAlert>
      ) : null}

      {confirmedRoomAlert ? (
        <SweetAlert
          success
          title={"Confirmado"}
          onConfirm={() => {
            getAllMatchFunc();
            setConfirmedRoomAlert(false);
          }}
        >
          Participantes confirmados com sucesso!
        </SweetAlert>
      ) : null}

      {alertDeleteAll ? (
        <SweetAlert
          success
          title={"Sucesso"}
          onConfirm={() => {
            getAllMatchFunc();
            setAlertDeleteAll(false);
          }}
        >
          Quartos deletados com sucesso
        </SweetAlert>
      ) : null}

      <Card>
        <CardBody>
          <div className="groups-match">
            <a className="title-theme-match">
              Personalizar Match de Hospedagem
            </a>

            <div className="group-btn-match header-btns-container">
              <Button
                color="success"
                className="btn-rounded waves-effect waves-light events-button-add"
                style={{ marginRight: 10 }}
                onClick={() => setModalLinksEmbded(true)}
              >
                Links Para Embedar
              </Button>

              <Button
                color="warning"
                className="btn-rounded waves-effect waves-light events-button-add"
                style={{ marginRight: 10 }}
                onClick={() => setModalEditStock(true)}
              >
                Editar Estoque
              </Button>

              <Button
                color="warning"
                className="btn-rounded waves-effect waves-light events-button-add"
                onClick={() => setModalConfig(true)}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <i
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "white",
                  }}
                  className="dripicons-gear"
                />
                <a style={{ display: "flex", alignItems: "center" }}>
                  Configurações
                </a>
              </Button>
            </div>
          </div>

          <div className="mobile-btn-section" style={{ width: "100%" }}>
            <a className="title-theme-match">Match de Participante</a>

            <SectionComponent
              sectionName="Opções"
              setIsOpen={setIsOpenMatch}
              isOpen={isOpenMatch}
            />
            <Collapse isOpen={isOpenMatch}>
              <Row className="mobile-btns-top">
                <div onClick={() => setModalLinksEmbded(true)}>
                  Links Para Embedar
                </div>
              </Row>

              {/* <Row className="mobile-btns-top">
                <div>Personalizar Match</div>
              </Row> */}

              <Row className="mobile-btns-top">
                <div onClick={() => setModalEditStock(true)}>
                  Editar Estoque
                </div>
              </Row>

              <Row className="mobile-btns-top">
                <div>Configurações</div>
              </Row>
            </Collapse>
          </div>

          <section className={"stock-card-container"}>
            {stockRooms && getCardStock()}
          </section>

          <div className="groups-match">
            <a className="title-theme-match">Relatório de Hospedagem</a>

            {/* <div className="group-btn-match">
              <Button
                color="success"
                className="btn-rounded waves-effect waves-light events-button-add"
                style={{ marginRight: 10 }}
                onClick={() => generateExcell() > setExportInProgress(true)}
              >
                Exportar Relatório
              </Button>
            </div> */}
          </div>

          {/* <div className="mobile-btn-section" style={{ width: "100%" }}>
            <a className="title-theme-match">Match de Participante</a>

            <SectionComponent
              sectionName="Opções"
              setIsOpen={setIsOpen}
              isOpen={isOpen}
            />
            <Collapse isOpen={isOpen}>
              <Row className="mobile-btns-top">
                <div>Editar Estoque</div>
              </Row>
            </Collapse>
          </div> */}

          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>

            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type="text"
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpenReport}
                isOpen={isOpenReport}
              />
              <Collapse isOpen={isOpenReport}>
                {data && data.length > 0 && (
                  <Row className="mobile-btns-top">
                    <div onClick={() => setModalExport(true)}>
                      Exportar Relatório de Quartos
                    </div>
                  </Row>
                )}

                <Row className="mobile-btns-top">
                  <div onClick={() => setModalExportNoRoom(true)}>
                    Exportar Participantes sem Quarto
                  </div>
                </Row>
              </Collapse>
            </div>

            <div className="header-btns-container">
              {/* <Button
                color="success"
                className="btn-rounded waves-effect waves-light events-button-add"
                style={{ marginRight: 10 }}
                onClick={() => setRandomMatchUsers(true)}
              >
                Gerar Quartos Automaticamente
              </Button> */}
              {/* {data && data.length > 0 && (
                <Button
                  color="success"
                  className="btn-rounded waves-effect waves-light events-button-add"
                  style={{ marginRight: 10 }}
                  onClick={() => setModalExport(true)}
                >
                  Exportar Relatório de Quartos
                </Button>
              )} */}
              {/* <Button
                color="success"
                className="btn-rounded waves-effect waves-light events-button-add"
                style={{ marginRight: 10 }}
                onClick={() => setModalExportNoRoom(true)}
              >
                Exportar Participantes sem Quarto
              </Button> */}

              {data && data.length > 0 && (
                <Button
                  color="secondary"
                  className="waves-effect waves-light events-button-add"
                  style={{ marginRight: 5 }}
                  onClick={() => {
                    setTransition(true);
                    setIsActiveRoom(!isActiveRoom);
                  }}
                >
                  {!isActiveRoom ? "Filtrar: Ativos" : "Filtrar: Inativos"}
                </Button>
              )}

              <Button
                color="success"
                className="waves-effect waves-light events-button-add"
                onClick={() => setModalDashboard(true)}
              >
                Dashboard
              </Button>

              {(amountNoRoom > 0 || data?.length > 0) && (
                <Dropdown
                  isOpen={dropdownOpen}
                  toggle={toggle}
                  direction={"down"}
                >
                  <DropdownToggle caret>Exportar</DropdownToggle>
                  <DropdownMenu
                    right
                    style={{ height: "auto", overflow: "hidden" }}
                  >
                    {amountNoRoom > 0 && (
                      <DropdownItem onClick={() => setModalExportNoRoom(true)}>
                        <i
                          style={{
                            marginRight: 10,
                          }}
                          className="dripicons-forward"
                        />
                        Exportar Participantes sem Quarto
                      </DropdownItem>
                    )}
                    {data && data.length > 0 && (
                      <DropdownItem onClick={() => setModalExport(true)}>
                        <i
                          style={{
                            marginRight: 10,
                          }}
                          className="dripicons-forward"
                        />
                        Exportar Relatório de Quartos
                      </DropdownItem>
                    )}
                    {data && data.length > 0 && (
                      <DropdownItem onClick={() => setModalExportByLine(true)}>
                        <i
                          style={{
                            marginRight: 10,
                          }}
                          className="dripicons-forward"
                        />
                        Exportar Relatório de Quartos Linha a Linha
                      </DropdownItem>
                    )}
                  </DropdownMenu>
                </Dropdown>
              )}
              {(amountNoRoom > 0 || pendingUsers > 0 || haveParticipants) && (
                <Dropdown
                  isOpen={dropdownRoom}
                  toggle={() => setDropdownRoom(!dropdownRoom)}
                  direction={"down"}
                >
                  <DropdownToggle caret>Gerenciar Quartos</DropdownToggle>
                  <DropdownMenu
                    right
                    style={{ height: "auto", overflow: "hidden" }}
                  >
                    {amountNoRoom > 0 && canCreate() && (
                      <DropdownItem onClick={() => setModalCreateMatch(true)}>
                        <i
                          style={{
                            marginRight: 10,
                          }}
                          className="dripicons-plus"
                        />
                        Criar Quarto
                      </DropdownItem>
                    )}

                    {canCreate() && (
                      <DropdownItem onClick={() => setModalImportRoom(true)}>
                        <i
                          style={{
                            marginRight: 10,
                          }}
                          className="dripicons-plus"
                        />
                        Importar Quartos
                      </DropdownItem>
                    )}

                    {amountNoRoom > 0 && (
                      <DropdownItem onClick={() => setRandomMatchUsers(true)}>
                        <i
                          style={{
                            marginRight: 10,
                          }}
                          className="dripicons-swap"
                        />
                        Gerar Quartos Automaticamente
                      </DropdownItem>
                    )}

                    {pendingUsers > 0 && canCreate() && (
                      <DropdownItem onClick={() => setConfirmPending(true)}>
                        <i
                          style={{
                            marginRight: 10,
                          }}
                          className="dripicons-checkmark"
                        />
                        Confirmar Todos Pendentes
                      </DropdownItem>
                    )}
                  </DropdownMenu>
                </Dropdown>
              )}
            </div>
          </div>

          <div className="table-responsive">
            <Table>
              <thead className="table-light">
                <tr>
                  <th>Hóspede 1</th>
                  <th>Hóspede 2</th>
                  <th>Hóspede 3</th>
                  <th>Hóspede 4</th>
                  <th>Tipo de Quarto</th>
                  {isActiveRoom && (
                    <th style={{ textAlign: "center" }}>Ações</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {loading && !transition ? (
                  <LoadingSkelentonTable lines={10} cols={isActiveRoom ? 6 : 5} />
                ) : (
                  data &&
                  data.map((e, i) => (
                    <tr key={i} style={{ cursor: "pointer" }}>
                      <td>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              display:
                                e.login_nome_1 == null ? "none" : "block",
                              height: 10,
                              width: 10,
                              flexShrink: 0,
                              minWidth: 10,
                              minHeight: 10,
                              borderRadius: 50,
                              backgroundColor:
                                e.login_status_1 === "completed"
                                  ? "#8bc34a"
                                  : "#ffc107",
                              marginRight: 3,
                            }}
                          />
                          {/* {e.login_nome_1 == null ? "-" : e.login_nome_1} */}
                          {e.login_nome_1
                            ? `${e.login_nome_1}${
                                e.restricao_hospedagem_1
                                  ? ` (Restrição: ${e.restricao_hospedagem_1})`
                                  : ""
                              }`
                            : "-"}
                        </div>
                      </td>
                      <td>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              display:
                                e.login_nome_2 == null ? "none" : "block",
                              height: 10,
                              width: 10,
                              flexShrink: 0,
                              minWidth: 10,
                              minHeight: 10,
                              borderRadius: 50,
                              backgroundColor:
                                e.login_status_2 === "completed"
                                  ? "#8bc34a"
                                  : "#ffc107",
                              marginRight: 3,
                            }}
                          />

                          {e.login_nome_2
                            ? `${e.login_nome_2}${
                                e.restricao_hospedagem_2
                                  ? ` (Restrição: ${e.restricao_hospedagem_2})`
                                  : ""
                              }`
                            : "-"}
                        </div>
                      </td>
                      <td>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              display:
                                e.login_nome_3 == null ? "none" : "block",
                              height: 10,
                              width: 10,
                              flexShrink: 0,
                              minWidth: 10,
                              minHeight: 10,
                              borderRadius: 50,
                              backgroundColor:
                                e.login_status_3 === "completed"
                                  ? "#8bc34a"
                                  : "#ffc107",
                              marginRight: 3,
                            }}
                          />
                          {/* {e.login_nome_3 == null ? "-" : e.login_nome_3} */}
                          {e.login_nome_3
                            ? `${e.login_nome_3}${
                                e.restricao_hospedagem_3
                                  ? ` (Restrição: ${e.restricao_hospedagem_3})`
                                  : ""
                              }`
                            : "-"}
                        </div>
                      </td>
                      <td>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              display:
                                e.login_nome_4 == null ? "none" : "block",
                              height: 10,
                              width: 10,
                              flexShrink: 0,
                              minWidth: 10,
                              minHeight: 10,
                              borderRadius: 50,
                              backgroundColor:
                                e.login_status_4 === "completed"
                                  ? "#8bc34a"
                                  : "#ffc107",
                              marginRight: 3,
                            }}
                          />
                          <span>
                            {/* {e.login_nome_4 == null ? "-" : e.login_nome_4} */}
                            {e.login_nome_4
                              ? `${e.login_nome_4}${
                                  e.restricao_hospedagem_4
                                    ? ` (Restrição: ${e.restricao_hospedagem_4})`
                                    : ""
                                }`
                              : "-"}
                          </span>
                        </div>
                      </td>
                      <td>
                        {e.room_size === 4 && "Quadruplo"}
                        {e.room_size === 3 && "Triplo"}
                        {e.room_size === 2 && "Duplo"}
                        {e.room_size === 1 && "Single"}
                      </td>
                      {isActiveRoom && (
                        <td style={{ textAlign: "center" }}>
                          {loading && transition ? (
                            <Spinner
                              style={{ color: "green" }}
                              animation="border"
                              size="sm"
                            />
                          ) : (
                            <>
                              {(e.login_status_1 === "pending_accept" ||
                                e.login_status_2 === "pending_accept" ||
                                e.login_status_3 === "pending_accept" ||
                                e.login_status_4 === "pending_accept") && (
                                <IconButton
                                  className="bx bx-check-circle"
                                  color="green"
                                  onClick={() =>
                                    setConfirmRoomData(e) > confirmRoom()
                                  }
                                  action="C"
                                />
                              )}
                              <DeleteButton
                                onClick={() => {
                                  {
                                    setSelectedMath(e);
                                    setConfirmDelete(true);
                                  }
                                }}
                                color="red"
                                fontSize={17}
                              />
                            </>
                          )}
                        </td>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
      <div
        className="bottom-navigation"
        style={{
          justifyContent: `${
            data?.length > 0 && showDeleteAll ? "space-between" : "end"
          }`,
        }}
      >
        {data && data.length > 0 && (
          <ActionButtonRounded
            onClick={() => setModalDeleteAll(true)}
            title="Limpar Todos Quartos"
            action="D"
            color="danger"
            className="btn-rounded waves-effect waves-light events-button-add-lg"
            setShow={setShowDeleteAll}
            verifyShow={true}
          />
        )}
        <Pagination
          data={data}
          search={search}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={count}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(Ranking);
